import React from 'react';
import { awards } from '../data/AwardsData';
import '../scss/components/Awards.scss';

const Awards = () => {
  return (
    <>
      <h1 className='no-select'>Projects</h1>
      {awards.map((award) => (
        <div key={award.key} className='awards'>
          <h3>{award.name}</h3>
          <p className='awards'>{award.additionalInformation}</p>
          <a style={{color:'white'}} href={award.link}>Link to the project</a>
        </div>
      ))}
    </>
  );
};

export default Awards;
